import type { Locale } from "@mw/shared/i18n";

export const LOCALIZED_LABELS: Record<Locale, string> = {
  sv: "Svenska",
  de: "Deutsch",
  hi: "हिन्दी",
  it: "Italiano",
  pl: "Polski",
  fr: "Français",
  ja: "日本語",
  ko: "한국어",
  es: "Español",
  en: "English",
  pt: "Português",
  zh: "简体中文",
};
